/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 開通エラー
 */
export interface Sgkb575aResProvError {
    /** 
     * 開通エラー発生システムコード：半角英数混在
     */
    prverrSyscd?: string;
    /** 
     * 開通エラー発生システムコード名称：全角半角混在
     */
    prverrSyscdAname?: string;
    /** 
     * 開通エラーメッセージレベル：半角英数混在
     */
    provErrmsg?: string;
    /** 
     * 開通エラーメッセージレベル名称：全角半角混在
     */
    provErrmsgAname?: string;
    /** 
     * 開通エラー理由：半角英数混在
     */
    provErrrsn?: string;
    /** 
     * 開通エラー理由名称：全角半角混在
     */
    provErrrsnAname?: string;
}
